<template>
  <div class="global-notice" v-if="notice.showNotice" :class="{ 'notice-closed': !showNotice }">
    <div class="notice-content">
      <!-- <i class="fas fa-bullhorn"></i> -->
      <span class="notice-text">{{ notice.content }}</span>
    </div>
    <!-- <button class="close-btn" @click="closeNotice" v-if="notice.closeable">
      <i class="fas fa-times"></i>
    </button> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GlobalNotice',
  data() {
    return {
    //   showNotice: true
    }
  },
  computed: {
    ...mapState({
      notice: state => state.notice,
      showNotice: state => state.notice.showNotice
    })
  },

  created() {
    //   const noticeId = localStorage.getItem('currentNoticeId') 
    //   if (noticeId && noticeId === this.notice.id) {
    //     this.closeNotice()
    //   } else {
    //     this.showNotice = true
    //   }
  },

  methods: {
    closeNotice() {
      this.showNotice = false
      this.$emit('notice-closed')
      localStorage.setItem('currentNoticeId', (this.notice.id + this.notice.updateTime)) 
      this.$store.commit('setNotice', { showNotice: false })
    }
  }
}
</script>

<style scoped>
.global-notice {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff8e1;
  background-image: url('../assets/top.jpg');
  background-size: cover; 
  background-repeat: no-repeat;
  background-position: top center;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  height: 40px;
  overflow: hidden;
}

.notice-closed {
  display: none;
}

.notice-content {
  display: flex;
  align-items: center;
  gap: 10px;
  /* color: #856404; */
  color: white;
}

.notice-text {
  font-size: 15px;
}

.close-btn {
  margin-left: 20px;
  background: none;
  border: none;
  color: #856404;
  cursor: pointer;
  padding: 4px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.close-btn:hover {
  opacity: 1;
}

@media (max-width: 768px) {
  .global-notice {
    padding: 8px 12px;
  }
}
</style>